module.exports = __webpack_public_path__ + "img/ele.ad14201a.png";